import { Grid } from "@mui/material";
import { Question } from "models/batch/Question";
import { AloveSwitch } from "components/alove/AloveSwitch";
import { updateBatchContentDO, updateQuestion } from "utils/questionsUtils";
import { BatchContent } from "models/batch/BatchContent";

const MDInput = require("components/MDInput/index.js").default;

export const QuestionHeader = ({
  question,
  setQuestion,
}: {
  question: Question;
  setQuestion: Function;
}) => {
  const batchContentsDisabled = (question.batchContents?.length ?? 0) > 1;

  const updateBatchContentField = async (field: string, value: any) => {
    const batchContents = question.batchContents ? [...question.batchContents] : [];
    if (batchContents[0]) {
      batchContents[0][field] = value;
      batchContents[0].questionId = question.id;
      setQuestion({ ...question, batchContents }, false);
      await updateBatchContentDO(batchContents[0].id, batchContents[0]);
    }
  }

  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          md: 6,
          xs: 12
        }}>
        <MDInput fullWidth multiline label="Question" value={question.txt} 
          onChange={(e) => setQuestion({ ...question, txt: e.target.value })} />
      </Grid>
      <Grid
        size={{
          md: 6,
          xs: 12
        }}>  </Grid>
      <Grid
        size={{
          md: 6,
          xs: 12
        }}>
        <MDInput fullWidth multiline label="Additional Info" value={question.visSettings?.txt_header2} 
          onChange={(e) => setQuestion({ ...question, visSettings: { ...question.visSettings, txt_header2: e.target.value } })} />
      </Grid>
      <Grid
        size={{
          md: 6,
          xs: 12
        }}>
        <AloveSwitch
          title="Skip Allowed"
          subtitle="Allow skipping this question in the batch"
          value={question.batchContents?.[0]?.skipAllowed || false}
          setValue={async (checked) => {
            await updateBatchContentField('skipAllowed', checked);
          }}
          disabled={batchContentsDisabled}
        />
      </Grid>
      <Grid
        size={{
          md: 6,
          xs: 12
        }}>
        <MDInput
          fullWidth
          label="Default Response"
          value={question.batchContents?.[0]?.defaultResponse || ''}
          disabled={batchContentsDisabled}
          onChange={async (e) => {
            await updateBatchContentField('defaultResponse', e.target.value);
          }}
        />
      </Grid>
      <Grid
        size={{
          md: 6,
          xs: 12
        }}>
        <AloveSwitch
          title="Return Back On Edit"
          subtitle="While editing the question, the user will be returned to this question"
          value={question.responseSettings?.returnBackOnEdit ?? false}
          setValue={async (checked) => {
            await setQuestion({...question, responseSettings: {...question.responseSettings, returnBackOnEdit: checked}});
          }}
          disabled={batchContentsDisabled}
        />
      </Grid>
      <Grid
        size={{
          md: 6,
          xs: 12
        }}>
        <MDInput
          fullWidth
          label="Version"
          type="number"
          value={question.batchContents?.[0]?.version ?? ''}
          disabled
        />
      </Grid>
      <Grid
        size={{
          md: 6,
          xs: 12
        }}>
        <AloveSwitch
          title="Pop question"
          subtitle="Pop this question to already answered users"
          value={question.responseSettings?.newVersion ?? false}
          setValue={async (checked) => {
            await setQuestion({...question, responseSettings: {...question.responseSettings, newVersion: checked}});
          }}
        />
      </Grid>
    </Grid>
  );
};
